module.exports = "/_next/static/images/maintenance-c0b2820b63c7ae89f1cdd061654bb189.svg";